import React from 'react';
import { useTranslation } from 'react-i18next';
import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';

import { SearchFacetRefinementSelect } from '@uncinc/react-searchkit';

import { TAXONOMY_WEIGHTS_PROJECT_STATUS, TAXONOMY_WEIGHTS_PROJECT_TYPE } from '../../../config/constants';

interface Weight {
  weight: number;
  value: string;
}

function sortItemsByWeight(items: RefinementListItem[], weights: Weight[]) {
  const itemsWithWeights = items.map((item) => {
    const matchingOrder = weights.find((o) => o.value === item.value);
    return {
      ...item,
      weight: matchingOrder?.weight ?? items.length,
    };
  });

  return itemsWithWeights.sort((a, b) => a.weight - b.weight);
}

const SELECT_MENU_MAX_HEIGHT = 450; // In px.

const SearchAllProjectsFacets: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <SearchFacetRefinementSelect
        attribute="project_type"
        placeholder={t('components.project_map.filters.project_type_placeholder')}
        transformItems={(items) => {
          return sortItemsByWeight(items, TAXONOMY_WEIGHTS_PROJECT_TYPE);
        }}
        // These React Select props haven't been properly typed yet
        // in both react-searchkit and uncinc-react-kitchen-sink.
        // @ts-expect-error
        maxMenuHeight={SELECT_MENU_MAX_HEIGHT}
      />

      <SearchFacetRefinementSelect
        attribute="project_status"
        placeholder={t('components.project_map.filters.project_status_placeholder')}
        transformItems={(items) => {
          return sortItemsByWeight(items, TAXONOMY_WEIGHTS_PROJECT_STATUS);
        }}
        // These React Select props haven't been properly typed yet
        // in both react-searchkit and uncinc-react-kitchen-sink.
        // @ts-expect-error
        maxMenuHeight={SELECT_MENU_MAX_HEIGHT}
      />
    </>
  );
};

export default SearchAllProjectsFacets;
